import React, { type FC } from "react";
import InsuranceService from "./services/InsuranceService";
import { useUscLabel, useUscOptionalLabel } from "../../../utils/labels";
import Text from "../../../../shared-components/toyota/styles/atoms/Text";
import * as Styles from "./ServicesWithDetailsList.styles";

/**
 * Renders the services which can be configured by pressing the 'show/edit details' buttons
 * This is currently only used for insurance
 */
const ServicesWithDetailsList: FC = () => {
    const titleLabel = useUscLabel("uscServicesInsuranceTitle");
    const disclaimerLabel = useUscOptionalLabel("uscServicesPdpDisclaimer");
    const ariaServicesTitleLabel = useUscLabel("uscA11yTabServices");

    return (
        <Styles.Wrapper aria-label={ariaServicesTitleLabel}>
            <Text tag="h2" variant="h4">
                {titleLabel}
            </Text>

            <InsuranceService />

            {disclaimerLabel && (
                <Text tag="p" variant="body-small-book" color="primary-black">
                    {disclaimerLabel}
                </Text>
            )}
        </Styles.Wrapper>
    );
};

export default ServicesWithDetailsList;
